import axios from "./axios";

export async function fetchCompanyEmployeePositions() {
  const response = await axios.get("/company/employee_positions");
  return response?.data || {};
}

export async function syncCompanyEmployeePositions(employeePositions) {
  const response = await axios.put("/company/employee_positions/sync", {
    employee_positions: employeePositions,
  });
  return response?.data || {};
}
